import type { AppRole, ApprovalStatus, EventStatus, RoleCategory } from '@/types/domain';

export const roleCategoryOptions: RoleCategory[] = ['DPS', 'Tank', 'Support', 'Battle Mount', 'Healer', 'Culler'];

export const appRoleOptions: AppRole[] = ['owner', 'admin', 'officer', 'mass_manager', 'member'];

export const approvalStatusOptions: ApprovalStatus[] = ['pending', 'approved', 'rejected', 'suspended'];

export const editableEventStatusOptions: EventStatus[] = ['draft', 'upcoming', 'open', 'closed', 'cancelled'];
